import { FaWhatsapp } from "react-icons/fa"
import FloatingButton from "../Widgets/Floating Button/FloatingButton"
import '../../Styles/Global/header.scss'

const WhatsappButton = () => {

    return <FloatingButton icon={<FaWhatsapp className="whatsapp-button-icon" />} className='whatsapp-button' content="Contactanos por Whatsapp" onClick={() => window.open('https://wa.me/+524494253166', '_blank')} />
}

export default WhatsappButton